import { tintFormTagName } from "../../../public/js/react/feature/form-builder/utils/form-builder.types";
const formTagNames = {
  div: "DIV",
  dialog: "DIALOG"
};
const fixFormsWithDivTag = () => {
  const oldEmbedForms = document.querySelectorAll("[data-team-id][data-form-id]");
  if (oldEmbedForms) {
    oldEmbedForms.forEach((form) => {
      if (form.tagName === formTagNames.div || form.tagName === formTagNames.dialog) {
        const tintForm = document.createElement(tintFormTagName);
        const formAttributes = Array.from(form.attributes);
        for (const attribute of formAttributes) {
          if (attribute.name.includes("data")) {
            const splitAttribute = attribute.name.split("data-");
            const extractedAttribute = splitAttribute == null ? void 0 : splitAttribute[1];
            tintForm.setAttribute(extractedAttribute, attribute.value);
          } else {
            tintForm.setAttribute(attribute.name, attribute.value);
          }
        }
        if (form.tagName === formTagNames.dialog) {
          const dialog = document.createElement("dialog");
          if (form.open) {
            dialog.setAttribute("open", true);
          }
          dialog.appendChild(tintForm);
          form.replaceWith(dialog);
        } else {
          form.replaceWith(tintForm);
        }
      }
    });
  }
};
export const OldFormsEmbedCodeService = {
  fixFormsWithDivTag
};
